import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import DisplayBoxLabel from '@client/components/displayBox/displayBoxLabel/DisplayBoxLabel';
import DisplayBoxLogo from '@client/components/displayBox/displayBoxLogo/DisplayBoxLogo';
import ReactLink from '@client/components/reactLink/ReactLink';
import { fakeEllipsis } from '@client/shared/utils/utils/utils';
import { SHORT_DESCRIPTION_LENGTH } from '@client/shared/js/constants';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import indicators from '@client/shared/js/indicators';
import { strings } from '@client/localization/Localization';
import styles from './fullwidthslides.scss';

class FullWidthSlides extends PureComponent {
  getDescriptionClassNames() {
    return classNames({
      [styles.description]: this.props.slide.slug,
      [styles.descriptionSpaced]: !this.props.slide.slug,
    });
  }

  getTextBoxClassNames() {
    return classNames({
      [styles.textBox]: true,
      [this.props.textBoxStyle]: this.props.textBoxStyle,
    });
  }

  render() {
    const { className, slide, route, hideEpisodeCount } = this.props;

    const bgStyle = {
      background: `url(${slide.heroImageUrl}) no-repeat`,
    };

    return (
      <div
        className={
          className
            ? `${styles.fullWidthSlide} ${className}`
            : styles.fullWidthSlide
        }
        style={bgStyle}
      >
        <div className={styles.overlay}>
          <div className={styles.fullWidthSlideContentContainer}>
            {slide.sponsor && (
              <DisplayBoxLogo
                className={styles.logo}
                logo={slide.sponsor.imageUrl}
                alt={slide.sponsor.title}
              />
            )}
            <div className={this.getTextBoxClassNames()}>
              {slide.categoryTitle && (
                <DisplayBoxLabel text={slide.categoryTitle} />
              )}
              <div
                className={
                  hideEpisodeCount ? styles.hidden : styles.episodeCount
                }
              >
                {slide.episodeCount || '0'} {strings.episodes}
              </div>
              <div className={styles.slideTitle}>{slide.title}</div>
              {slide.description && (
                <div className={this.getDescriptionClassNames()}>
                  {fakeEllipsis(slide.description, SHORT_DESCRIPTION_LENGTH)}
                </div>
              )}
              {slide.slug && (
                <ReactLink to={route}>
                  <button
                    type="button"
                    className={`${themeStyles.btnPrimary} ${styles.button}`}
                  >
                    <img src={indicators.arrow_black} />
                    {strings.playVideo}
                  </button>
                </ReactLink>
              )}
            </div>
          </div>
          <div className={styles.extraBackground}></div>
        </div>
      </div>
    );
  }
}

FullWidthSlides.propTypes = {
  slide: PropTypes.object,
  className: PropTypes.string,
  textBoxStyle: PropTypes.string,
  alt: PropTypes.string,
  route: PropTypes.string,
  hideEpisodeCount: PropTypes.bool,
};

export default FullWidthSlides;
